import styled from 'styled-components';

export const ShowMdUp = styled.span`
  display: none;
  @media (min-width: 768px) {
    display: inline;
  }
`;
